import { TrendingUp, Users, Target, XCircle } from "lucide-react";
import SalesChart from "./SalesChart";
import SalesSidebar from "./SalesSidebar";

export default function SalesReport({ data }) {
  if (!data) return null;

  var totalLeads = data.total_leads || 0;
  var totalClosed = data.total_closed || 0;
  var totalLost = data.total_lost || 0;
  var convRate = data.conversion_rate || 0;
  var monthly = data.monthly || [];

  return (
    <div data-testid="sales-report">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
          <div className="flex items-center gap-2 mb-2">
            <div className="p-1.5 rounded-lg bg-blue-50"><Users className="w-4 h-4 text-[#3B82F6]" /></div>
            <span className="text-xs text-gray-500">Total Leads</span>
          </div>
          <p className="text-2xl font-bold text-[#0A2F3D]" data-testid="sales-total-leads">{totalLeads}</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
          <div className="flex items-center gap-2 mb-2">
            <div className="p-1.5 rounded-lg bg-emerald-50"><Target className="w-4 h-4 text-emerald-500" /></div>
            <span className="text-xs text-gray-500">Fechados</span>
          </div>
          <p className="text-2xl font-bold text-emerald-600" data-testid="sales-total-closed">{totalClosed}</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
          <div className="flex items-center gap-2 mb-2">
            <div className="p-1.5 rounded-lg bg-red-50"><XCircle className="w-4 h-4 text-red-500" /></div>
            <span className="text-xs text-gray-500">Perdidos</span>
          </div>
          <p className="text-2xl font-bold text-red-500" data-testid="sales-total-lost">{totalLost}</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
          <div className="flex items-center gap-2 mb-2">
            <div className="p-1.5 rounded-lg bg-emerald-50"><TrendingUp className="w-4 h-4 text-emerald-500" /></div>
            <span className="text-xs text-gray-500">Conversao</span>
          </div>
          <p className="text-2xl font-bold text-emerald-600" data-testid="sales-conversion">{convRate}%</p>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 bg-white rounded-xl p-4 shadow-sm border border-gray-100">
          <h4 className="text-sm font-semibold text-[#0A2F3D] mb-4">Evolucao Mensal</h4>
          <SalesChart monthly={monthly} />
        </div>
        <SalesSidebar byStatus={data.by_status} byProduct={data.by_product} />
      </div>
    </div>
  );
}
